import { ThumbsUp } from "lucide-react";
import posthog from "posthog-js";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "~/components/ui/popover";

import { SidebarMenuButton } from "~/components/ui/sidebar";
import "./feedback-button.css";

export function FeedbackButton({ showTooltip }: { showTooltip: boolean }) {
  const [loaded, setLoaded] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    posthog.onSurveysLoaded(() => {
      setLoaded(true);
    });
  }, []);

  return (
    <>
      <Popover
        open={open}
        onOpenChange={(open) => {
          if (!loaded) {
            toast.info("Survey is loading, please try again in a few seconds");
            return;
          }
          setOpen(open);
        }}
      >
        <PopoverTrigger asChild>
          <SidebarMenuButton
            tooltip={{ children: "Feedback", hidden: !showTooltip }}
            isActive={open}
          >
            <ThumbsUp />
            Feedback
          </SidebarMenuButton>
        </PopoverTrigger>
        <PopoverContent side="right" collisionPadding={12} className="min-w-80">
          <PostHogSurvey surveyId={import.meta.env.VITE_FEEDBACK_SURVEY_ID} />
        </PopoverContent>
      </Popover>
    </>
  );
}

function PostHogSurvey({
  surveyId,
}: {
  surveyId: string;
}) {
  useEffect(() => {
    posthog.renderSurvey(surveyId, "#survey-container");
  }, [surveyId]);

  return <div id="survey-container"></div>;
}
